import * as React from 'react';
import RangeEditor from './RangeEditor';
import RangeValueSwitch from './RangeValueSwitch';
import ValueBaseEditor from './ValueBaseEditor';
import VariationEditor from './VariationEditor';
import FixedGuidance from '../../../../../../models/data/FixedGuidance';
const FixedGuidanceEditor = ({ value, onChange }) => {
    const [rangeValue, setRangeValue] = React.useState(value?.range !== undefined ? 'range' : 'value');
    const onChangeRange = React.useCallback((event) => {
        const updated = value !== undefined ? value.updateRange(event.target.value) : new FixedGuidance({ range: event.target.value });
        onChange({ target: { value: updated } });
    }, [onChange, value]);
    const onChangeValue = React.useCallback((event) => {
        const updated = value !== undefined ? value.updateValue(event.target.value) : new FixedGuidance({ value: event.target.value });
        onChange({ target: { value: updated } });
    }, [onChange, value]);
    const onChangeVariation = React.useCallback((event) => {
        const updated = value !== undefined ? value.updateVariation(event.target.value) : new FixedGuidance({ variation: event.target.value });
        onChange({ target: { value: updated } });
    }, [onChange, value]);
    const content = React.useMemo(() => {
        switch (rangeValue) {
            case 'range':
                return React.createElement(RangeEditor, { value: value?.range, onChange: onChangeRange });
            case 'value':
                return React.createElement(ValueBaseEditor, { value: value?.value, onChange: onChangeValue });
            default:
                return undefined;
        }
    }, [onChangeRange, onChangeValue, rangeValue, value?.range, value?.value]);
    return (React.createElement(React.Fragment, null,
        React.createElement(RangeValueSwitch, { name: "fixed", rangeValue: rangeValue, setRangeValue: setRangeValue }),
        React.createElement("div", { style: { display: 'flex' } },
            content,
            React.createElement(VariationEditor, { value: value?.variation, onChange: onChangeVariation }))));
};
export default FixedGuidanceEditor;
